<template>
  <fragment>
    <search-nav-start-end label="작성일" v-model="nav.created_at"/>
    <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="searchTypes" />
    <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.searchKeyword" />
  </fragment>
</template>

<script>
import SearchNavStartEnd from '@/components/nav/SearchNavStartEnd.vue'
import SearchNav from '@/components/nav/SearchNav'
import SearchNavItemKeyword from '@/components/nav/SearchNavItemKeyword'
import SearchNavItemSelect from '@/components/nav/SearchNavItemSelect'

export default {
  name: 'NormalSearchNav101',
  components: {
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNav,
    SearchNavStartEnd
  },
  watch: {
    nav: {
      immediate: true,
      deep: true,
      handler () {
        this.$emit('input', this.nav)
      }
    }
  },
  computed: {
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    is내부종사자 () {
      return `${this.projectId}` === '2'
    }
  },
  data () {
    return {
      nav: {
        created_at: '',

        searchType: '',
        searchKeyword: '',
      },
      searchTypes: [
        {text: '사업장명', value:'사업장명'},
        {text: '소속명', value:'소속명'},
        {text: '부서명', value:'부서명'},
        {text: '작성자', value:'작성자'},
      ],
    }
  },
  created() {
    this.searchTypes =  [
      {text: '사업장명', value: '사업장명'},
      {text: '소속명', value: '소속명'},
      {text: '부서명', value: '부서명'},
      {text: '작성자', value: '작성자'},
    ]
  }
}
</script>

<style scoped>

</style>
